export const ROUTE_IDS = {
  ADMIN_TENANTS: 'admin-tenants',
  ADMIN_TENANTS_CREATE: 'admin-tenants-create',
  ADMIN_TENANT_USERS: 'admin-tenant-users',
  ADMIN_CONTROL_PLANE_CLIENTS: 'admin-control-plane-clients',
  ADMIN_CONTROL_PLANE_CLIENT_DETAIL: 'admin-control-plane-client-detail',
  ADMIN_REPOSITORY: 'admin-repository',
  ADMIN_ASSETS: 'admin-assets',
  ADMIN_BILLING: 'admin-billing',
  ADMIN_NOTIFICATIONS: 'admin-notifications',
  WORKSPACE_USERS: 'workspace-users',
  DASHBOARD: 'dashboard',
  ASSIGNMENTS: 'assignments',
  DEAL_PROPOSALS: 'deal-proposals',
  DEALS_IN_PROGRESS: 'deals-in-progress',
  DEALS_COMPLETED: 'deals-completed',
  CLIENTS: 'clients',
  SUPPLIERS: 'suppliers',
  SUPPLIER_DETAIL: 'supplier-detail',
  STAFF: 'staff',
  CALENDAR: 'calendar',
  DOCUMENTS: 'documents',
  ACCOUNTING: 'accounting',
  EXPENSES: 'expenses',
  AUTOMATIONS: 'automations',
  SETTINGS: 'settings',
  CLIENTS_LEGACY_REDIRECT: 'clients-legacy-redirect',
  SUPPLIERS_LEGACY_REDIRECT: 'suppliers-legacy-redirect',
};

export const SHELL_IDS = {
  TENANT: 'tenant',
  ADMIN: 'admin',
};
